import React, { useEffect, useState } from "react";
import { Avatar, Badge, Box, Chip, Collapse, Divider, Drawer, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import FlightTakeoffOutlinedIcon from "@mui/icons-material/FlightTakeoffOutlined";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AutoModeOutlinedIcon from "@mui/icons-material/AutoModeOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { useAuth } from "../../context/AuthContext";
import { useModules } from "../../context/ModulesContext";
import { useNotifications } from "../../context/NotificationContext";

const SIDEBAR_WIDTH = 260;
const SIDEBAR_WIDTH_COLLAPSED = 76;

const NAV = [
  { label: "Dashboard", icon: DashboardOutlinedIcon, path: "/EmployeeDashboard" },
  {
    group: "MY WORK",
    items: [
      { label: "Attendance", icon: AccessTimeOutlinedIcon, path: "/AttendancePortal" },
      { label: "My Attendance", icon: FactCheckOutlinedIcon, path: "/GetMyAttendance" },
      { label: "Attendance Regularization", icon: FactCheckOutlinedIcon, path: "/AttendanceRegularization" },
      { label: "My Assets", icon: Inventory2OutlinedIcon, path: "/MyInventories", moduleKey: "inventory" },
      { label: "Apply Leave", icon: BeachAccessOutlinedIcon, path: "/ApplyForLeave" },
      { label: "My Leaves", icon: NoteAltOutlinedIcon, path: "/leave/my" },
      { label: "Encashment + Comp-off", icon: BeachAccessOutlinedIcon, path: "/leave/advanced?tab=encashment" },
      { label: "Overtime", icon: AccessTimeOutlinedIcon, path: "/overtime", moduleKey: "overtime" },
      { label: "My Timesheets", icon: ListAltOutlinedIcon, path: "/viewAllTimesheets", moduleKey: "timesheet" },
      { label: "Log Timesheet", icon: NoteAltOutlinedIcon, path: "/submit-timesheet", moduleKey: "timesheet" },
      { label: "Submit Reimbursement", icon: ReceiptLongOutlinedIcon, path: "/ReimbursementForm", moduleKey: "reimbursement" },
      { label: "My Reimbursements", icon: ReceiptLongOutlinedIcon, path: "/my-reimbursements", moduleKey: "reimbursement" },
      { label: "Travel", icon: FlightTakeoffOutlinedIcon, path: "/travel", moduleKey: "travel" },
      { label: "My Payslips", icon: PaymentsOutlinedIcon, path: "/payroll/my-payslips" },
      { label: "My Goals", icon: FlagOutlinedIcon, path: "/goals", moduleKey: "goals" },
      { label: "Check-ins / 1:1", icon: HandshakeOutlinedIcon, path: "/check-ins", moduleKey: "goals" },
      { label: "My Manager Feedback", icon: RateReviewOutlinedIcon, path: "/employee-feedback", moduleKey: "feedbackForms" },
      { label: "Self Assessment", icon: AssessmentOutlinedIcon, path: "/SelfAssessmentForm", moduleKey: "performance" },
      { label: "My Self Assessments", icon: FactCheckOutlinedIcon, path: "/my-self-assessments", moduleKey: "performance" },
      { label: "My Calendar", icon: CalendarMonthOutlinedIcon, path: "/CalendarView" },
      { label: "My Profile", icon: AssignmentIndOutlinedIcon, path: "/me" },
      { label: "My Documents", icon: FactCheckOutlinedIcon, path: "/my-documents" },
      { label: "My Letters", icon: NoteAltOutlinedIcon, path: "/letters" },
      { label: "IT Declaration", icon: PaymentsOutlinedIcon, path: "/payroll/declaration" },
      { label: "Flex Benefits", icon: PaymentsOutlinedIcon, path: "/payroll/fbp" },
    ],
  },
  {
    group: "DISCOVER",
    items: [
      { label: "Team Directory", icon: PeopleAltOutlinedIcon, path: "/directory" },
      { label: "Org Chart", icon: AccountTreeOutlinedIcon, path: "/org-chart" },
      { label: "Announcements", icon: CampaignOutlinedIcon, path: "/announcements", moduleKey: "announcements" },
      { label: "Company Holidays", icon: CalendarMonthOutlinedIcon, path: "/holidays" },
      { label: "Policies", icon: GavelOutlinedIcon, path: "/policies", moduleKey: "policies" },
      { label: "Kudos Wall", icon: EmojiEventsOutlinedIcon, path: "/kudos", moduleKey: "engagement" },
      { label: "Surveys", icon: PollOutlinedIcon, path: "/surveys", moduleKey: "engagement" },
      { label: "Learning", icon: SchoolOutlinedIcon, path: "/training", moduleKey: "training" },
    ],
  },
  {
    group: "PROJECTS",
    items: [
      { label: "All Projects", icon: AccountTreeOutlinedIcon, path: "/projects", moduleKey: "projects" },
      { label: "Teams", icon: PeopleAltOutlinedIcon, path: "/projects/teams", moduleKey: "projects" },
      { label: "Whiteboard", icon: DrawOutlinedIcon, path: "/Whiteboard", moduleKey: "whiteboard" },
      { label: "Docs & Wiki", icon: MenuBookOutlinedIcon, path: "/docs", moduleKey: "docs" },
    ],
  },
  {
    group: "TEAM MANAGEMENT",
    items: [
      { label: "Leave Approvals", icon: BeachAccessOutlinedIcon, path: "/leave/approvals", access: "approver" },
      { label: "Team Leave Balances", icon: EventAvailableOutlinedIcon, path: "/leave/team-balances", access: "approver" },
      { label: "Team Attendance Report", icon: FactCheckOutlinedIcon, path: "/attendance/team-report", access: "critical" },
      { label: "Attendance Approvals", icon: FactCheckOutlinedIcon, path: "/ManagerAttendanceApprovals", access: "approver" },
      { label: "Overtime Approvals", icon: AccessTimeOutlinedIcon, path: "/overtime/approvals", moduleKey: "overtime", access: "approver" },
      { label: "Reimbursement Approvals", icon: ReceiptLongOutlinedIcon, path: "/reimbursements/approvals", moduleKey: "reimbursement", access: "approver" },
      { label: "Travel Approvals", icon: FlightTakeoffOutlinedIcon, path: "/travel/approvals", moduleKey: "travel", access: "approver" },
      { label: "Timesheet Access", icon: NoteAltOutlinedIcon, path: "/timesheetacess", moduleKey: "timesheet", access: "critical" },
      { label: "Inventory", icon: Inventory2OutlinedIcon, path: "/InventoryList", moduleKey: "inventory", access: "critical" },
      { label: "Manager Feedback", icon: AssessmentOutlinedIcon, path: "/ManagerFeedbackForm", moduleKey: "feedbackForms", access: "approver" },
      { label: "Manager Feedback Records", icon: FactCheckOutlinedIcon, path: "/manager-feedback", moduleKey: "feedbackForms", access: "approver" },
      { label: "Team Self Assessments", icon: AssignmentIndOutlinedIcon, path: "/team-self-assessments", moduleKey: "performance", access: "approver" },
      { label: "My Reviews", icon: AssessmentOutlinedIcon, path: "/my-reviews", moduleKey: "performance", access: "approver" },
      { label: "Recruitment Approvals", icon: WorkOutlineIcon, path: "/approvals/recruitment", moduleKey: "recruitment", access: "critical" },
    ],
  },
  {
    group: "PEOPLE",
    items: [
      { label: "Employees", icon: PeopleAltOutlinedIcon, path: "/employees", access: "critical" },
      { label: "Add Employee", icon: GroupAddOutlinedIcon, path: "/create-employee", access: "critical" },
      { label: "Archived", icon: PeopleAltOutlinedIcon, path: "/ArchivedEmployeeList", access: "critical" },
      { label: "Onboarding", icon: AssignmentIndOutlinedIcon, path: "/onboarding", moduleKey: "onboarding", access: "critical" },
      { label: "Offboarding", icon: LogoutOutlinedIcon, path: "/offboarding", moduleKey: "offboarding", access: "critical" },
    ],
  },
  {
    group: "PAYROLL & FINANCE",
    access: "critical",
    items: [
      { label: "Run Payroll", icon: PaymentsOutlinedIcon, path: "/payroll/run" },
      { label: "Batch Payroll", icon: PaymentsOutlinedIcon, path: "/payroll/batch" },
      { label: "Loans", icon: PaymentsOutlinedIcon, path: "/payroll/loans" },
      { label: "Salary Revisions", icon: PaymentsOutlinedIcon, path: "/payroll/revisions", moduleKey: "salaryRevisions" },
      { label: "Statutory", icon: GavelOutlinedIcon, path: "/payroll/statutory", badge: "PRO", moduleKey: "statutory" },
      { label: "Payroll Config", icon: SettingsOutlinedIcon, path: "/payroll/config" },
      { label: "All Reimbursements", icon: ReceiptLongOutlinedIcon, path: "/reimbursements", moduleKey: "reimbursement" },
      { label: "Expense Dashboard", icon: AssessmentOutlinedIcon, path: "/ExpenseDashboard", moduleKey: "reimbursement" },
      { label: "IT Declarations (Admin)", icon: PaymentsOutlinedIcon, path: "/payroll/declarations-admin" },
      { label: "FBP Admin", icon: PaymentsOutlinedIcon, path: "/payroll/fbp-admin" },
    ],
  },
  {
    group: "PERFORMANCE",
    items: [
      { label: "Review Cycles", icon: AssessmentOutlinedIcon, path: "/review-cycles", access: "critical", moduleKey: "performance" },
      { label: "9-Box Grid", icon: InsightsOutlinedIcon, path: "/nine-box", access: "critical", moduleKey: "performance" },
      { label: "PIPs", icon: FlagOutlinedIcon, path: "/pips", moduleKey: "performance" },
    ],
  },
  {
    group: "RECRUITMENT",
    items: [
      { label: "Jobs", icon: WorkOutlineIcon, path: "/recruitment/jobs", moduleKey: "recruitment" },
      { label: "Referrals", icon: PeopleAltOutlinedIcon, path: "/referrals", moduleKey: "recruitment" },
      { label: "Talent Pool", icon: PeopleAltOutlinedIcon, path: "/recruitment/talent-pool", access: "critical", moduleKey: "recruitment" },
      { label: "Analytics", icon: InsightsOutlinedIcon, path: "/recruitment/analytics", access: "critical", moduleKey: "recruitment" },
    ],
  },
  {
    group: "HR SETUP",
    access: "critical",
    items: [
      { label: "Manage Holidays", icon: CalendarMonthOutlinedIcon, path: "/holidays" },
      { label: "Team Calendar", icon: CalendarMonthOutlinedIcon, path: "/attendance/team-calendar" },
      { label: "Leave Types", icon: BeachAccessOutlinedIcon, path: "/leave/types" },
      { label: "Shifts", icon: AccessTimeOutlinedIcon, path: "/attendance/shifts" },
      { label: "Geo-fences", icon: FactCheckOutlinedIcon, path: "/attendance/geo-fences" },
      { label: "Office IPs", icon: FactCheckOutlinedIcon, path: "/attendance/office-ips", roles: ["admin"] },
    ],
  },
  {
    group: "COMMUNICATION",
    items: [
      { label: "Messages", icon: ChatBubbleOutlineIcon, path: "/MyMessages" },
      { label: "Out of Office", icon: ChatBubbleOutlineIcon, path: "/messages/out-of-office" },
      { label: "Chat", icon: ChatBubbleOutlineIcon, path: "/chatboard", moduleKey: "chat" },
      { label: "Help Desk", icon: SupportAgentOutlinedIcon, path: "/helpdesk", moduleKey: "helpdesk" },
      { label: "Knowledge Base", icon: HubOutlinedIcon, path: "/kb", moduleKey: "helpdesk" },
    ],
  },
  {
    group: "ANALYTICS & ADMIN",
    items: [
      { label: "Reports", icon: AssessmentOutlinedIcon, path: "/reports", access: "critical" },
      { label: "Custom Reports", icon: AssessmentOutlinedIcon, path: "/reports/builder", access: "critical" },
      { label: "Scheduled Reports", icon: AssessmentOutlinedIcon, path: "/reports/scheduled", access: "critical" },
      { label: "Weekly Attendance", icon: AssessmentOutlinedIcon, path: "/reports/attendance-weekly", access: "critical" },
      { label: "Helpdesk Admin", icon: SupportAgentOutlinedIcon, path: "/helpdesk/admin", access: "critical", moduleKey: "helpdesk" },
      { label: "DEI Insights", icon: InsightsOutlinedIcon, path: "/reports/dei", moduleKey: "analytics", access: "critical" },
      { label: "Attrition Risk", icon: InsightsOutlinedIcon, path: "/reports/attrition-risk", badge: "AI", access: "critical", moduleKey: "analytics" },
      { label: "Workflows", icon: AutoModeOutlinedIcon, path: "/workflows", access: "critical", moduleKey: "workflows" },
      { label: "Integrations", icon: HubOutlinedIcon, path: "/integrations", access: "critical", moduleKey: "integrationsStore" },
      { label: "Event Webhooks", icon: HubOutlinedIcon, path: "/integrations/webhooks", access: "critical", moduleKey: "integrationsStore" },
      { label: "API Keys", icon: SecurityOutlinedIcon, path: "/integrations/api-keys", roles: ["admin"] },
      { label: "Audit Log", icon: SecurityOutlinedIcon, path: "/security/audit-log", access: "critical" },
      { label: "Module Settings", icon: SettingsOutlinedIcon, path: "/settings/modules", roles: ["admin"] },
    ],
  },
  {
    group: "ACCOUNT",
    items: [
      { label: "Two-Factor Auth", icon: SecurityOutlinedIcon, path: "/security/2fa" },
      { label: "Active Sessions", icon: SecurityOutlinedIcon, path: "/security/sessions" },
      { label: "Notifications", icon: SecurityOutlinedIcon, path: "/settings/notifications" },
    ],
  },
];

function navEntries() {
  return NAV.flatMap((g) =>
    Array.isArray(g.items)
      ? g.items.filter((i) => i.path).map((i) => ({ ...i, group: g.group }))
      : g.path
        ? [{ ...g, group: g.group || null }]
        : []
  );
}

function pathMatchesItem(pathname, itemPath) {
  if (!itemPath) return false;
  if (pathname === itemPath) return true;
  if (pathname.startsWith(`${itemPath}/`)) return true;
  if (itemPath === "/submit-timesheet" && pathname === "/timesheet") return true;
  return false;
}

/** Prefer the longest matching item so /overtime/approvals does not highlight /overtime. */
function bestNavMatch(pathname) {
  const matches = navEntries().filter((i) => pathMatchesItem(pathname, i.path));
  if (!matches.length) return null;
  matches.sort((a, b) => String(b.path).length - String(a.path).length);
  return matches[0];
}

export default function AppSidebar({ open = true, onToggle, mobile = false, onNavigate }) {
  const theme = useTheme();
  const location = useLocation();
  const { user, hasRole, hasAccess } = useAuth();
  const { isEnabled } = useModules();
  const { chatUnread } = useNotifications();
  // Default MY WORK expanded on first load; route effect opens the matching group when navigating.
  const [openGroup, setOpenGroup] = useState("MY WORK");

  const isDark = theme.palette.mode === "dark";
  const width = open ? SIDEBAR_WIDTH : SIDEBAR_WIDTH_COLLAPSED;
  // Respect the item's roles list exactly — the old admin/hr bypass made HR
  // see admin-only entries (API Keys, Module Settings) only to hit Access
  // Denied on click. Every admin-relevant entry lists "admin" explicitly.
  const visibleFor = (roles, access) => {
    if (access) return hasAccess(access);
    if (!roles || roles.length === 0) return true;
    return hasRole(...roles);
  };

  // Auto-open the group containing the current route (so accordion shows the right section).
  useEffect(() => {
    const path = location.pathname;
    const match = bestNavMatch(path);
    if (match?.group) setOpenGroup(match.group);
    else if (path === "/EmployeeDashboard" || path === "/" || path.startsWith("/EmployeeDashboard")) {
      setOpenGroup("MY WORK");
    }
  }, [location.pathname]);

  const isGroupExpanded = (group) => openGroup === group.group;

  const toggleGroup = (g) => setOpenGroup((curr) => (curr === g ? null : g));

  const renderItem = (item) => {
    if (!visibleFor(item.roles, item.access)) return null;
    if (item.moduleKey && !isEnabled(item.moduleKey)) return null;
    const Icon = item.icon;
    const active = bestNavMatch(location.pathname)?.path === item.path;
    const content = (
      <ListItemButton
        component={NavLink}
        to={item.path}
        end
        selected={active}
        onClick={onNavigate}
        sx={{
          mx: 1,
          my: 0.25,
          borderRadius: 2,
          minHeight: 42,
          px: open ? 1.5 : 1,
          justifyContent: open ? "flex-start" : "center",
          "&:hover": {
            bgcolor: isDark ? "rgba(255,255,255,0.04)" : "rgba(108,80,191,0.06)",
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: open ? 36 : "auto",
            color: active ? "primary.main" : "text.secondary",
            justifyContent: "center",
          }}
        >
          <Badge
            variant={item.path === "/chatboard" && chatUnread > 0 ? "dot" : "standard"}
            badgeContent={item.path === "/chatboard" && chatUnread > 0 && !open ? chatUnread : 0}
            color="error"
            overlap="circular"
            max={99}
            invisible={item.path !== "/chatboard" || !chatUnread}
            sx={{ "& .MuiBadge-badge": { fontSize: 9, fontWeight: 800, minWidth: 16, height: 16 } }}
          >
            <Icon sx={{ fontSize: 20 }} />
          </Badge>
        </ListItemIcon>
        {open && (
          <>
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{ fontSize: 13.5, fontWeight: active ? 600 : 500 }}
            />
            {item.path === "/chatboard" && chatUnread > 0 && (
              <Box
                sx={{
                  minWidth: 18,
                  height: 18,
                  px: 0.5,
                  borderRadius: "9px",
                  bgcolor: "#ef4444",
                  color: "#fff",
                  fontSize: 10,
                  fontWeight: 800,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1,
                }}
              >
                {chatUnread > 99 ? "99+" : chatUnread}
              </Box>
            )}
            {item.badge && (
              <Chip
                size="small"
                label={item.badge}
                sx={{
                  height: 18,
                  fontSize: 9,
                  fontWeight: 700,
                  bgcolor: item.badge === "PRO" ? "#FFF4D6" : item.badge === "AI" ? "#F4EDFA" : "#EDF3FA",
                  color: item.badge === "PRO" ? "#8a6600" : item.badge === "AI" ? "#6C50BF" : "#1e4ea8",
                  "& .MuiChip-label": { px: 0.75 },
                }}
              />
            )}
          </>
        )}
      </ListItemButton>
    );
    if (!open) {
      return (
        <Tooltip title={item.label} placement="right" key={item.path} arrow>
          <Box>{content}</Box>
        </Tooltip>
      );
    }
    return <Box key={item.path}>{content}</Box>;
  };

  const renderGroup = (group, idx) => {
    if ((group.roles || group.access) && !visibleFor(group.roles, group.access)) return null;
    const visibleItems = (group.items || []).filter(
      (i) => visibleFor(i.roles, i.access) && (!i.moduleKey || isEnabled(i.moduleKey))
    );
    if (visibleItems.length === 0) return null;
    const isExp = isGroupExpanded(group);
    const groupHasChatUnread =
      chatUnread > 0 && (group.items || []).some((i) => i.path === "/chatboard");
    return (
      <Box key={group.group || idx} sx={{ mb: 0.5 }}>
        {open && (
          <Box
            onClick={() => toggleGroup(group.group)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              px: 2,
              py: 0.75,
              "&:hover .group-label": { color: "primary.main" },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
              <Typography
                className="group-label"
                sx={{
                  fontSize: 10.5,
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  color: "text.disabled",
                  transition: "color 0.2s",
                }}
              >
                {group.group}
              </Typography>
              {groupHasChatUnread && !isExp && (
                <Box
                  aria-label={`${chatUnread} unread chat messages`}
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    bgcolor: "#ef4444",
                    flexShrink: 0,
                  }}
                />
              )}
            </Box>
            {isExp ? <ExpandLessIcon sx={{ fontSize: 16, color: "text.disabled" }} /> : <ExpandMoreIcon sx={{ fontSize: 16, color: "text.disabled" }} />}
          </Box>
        )}
        <Collapse in={open ? isExp : true} timeout="auto" unmountOnExit={open}>
          {visibleItems.map(renderItem)}
        </Collapse>
      </Box>
    );
  };

  const drawerContent = (
    <Box
      sx={{
        width,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        transition: theme.transitions.create("width"),
        overflow: "hidden",
        bgcolor: "background.default",
      }}
    >
      {/* Brand */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={open ? "space-between" : "center"}
        sx={{
          px: open ? 2.5 : 0,
          py: 2,
          minHeight: 64,
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        {open ? (
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 2,
                background: "linear-gradient(135deg, #6C50BF 0%, #492ba3 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: 800,
                fontSize: 16,
              }}
            >
              IU
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 800, fontSize: 18, lineHeight: 1, color: "text.primary" }}>
                InfyU
              </Typography>
              <Typography sx={{ fontSize: 10, color: "text.secondary", fontWeight: 500, letterSpacing: "0.05em" }}>
                HRMS PORTAL
              </Typography>
            </Box>
          </Stack>
        ) : (
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 2,
              background: "linear-gradient(135deg, #6C50BF 0%, #492ba3 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: 800,
              fontSize: 16,
            }}
          >
            IU
          </Box>
        )}
        {!mobile && open && (
          <IconButton size="small" onClick={onToggle} sx={{ color: "text.secondary" }}>
            <ChevronRightIcon sx={{ transform: "rotate(180deg)" }} />
          </IconButton>
        )}
      </Stack>

      {/* Nav */}
      <Box sx={{ flex: 1, overflowY: "auto", overflowX: "hidden", py: 1 }}>
        <List dense disablePadding>
          {NAV.map((n, idx) => (n.group ? renderGroup(n, idx) : renderItem(n)))}
        </List>
      </Box>

      {/* User footer */}
      <Divider />
      {user && (
        <Stack
          direction="row"
          spacing={1.25}
          alignItems="center"
          sx={{
            px: open ? 2 : 0,
            py: 1.5,
            justifyContent: open ? "flex-start" : "center",
            bgcolor: "background.paper",
          }}
        >
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            badgeContent={
              <Box sx={{ width: 10, height: 10, bgcolor: "success.main", border: "2px solid", borderColor: "background.paper", borderRadius: "50%" }} />
            }
          >
            <Avatar
              sx={{
                width: 36,
                height: 36,
                background: "linear-gradient(135deg, #6C50BF 0%, #492ba3 100%)",
                color: "white",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              {(user.name || "U").slice(0, 1).toUpperCase()}
            </Avatar>
          </Badge>
          {open && (
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, lineHeight: 1.2 }} noWrap>
                {user.name}
              </Typography>
              <Typography sx={{ fontSize: 11, color: "text.secondary", textTransform: "capitalize" }} noWrap>
                {user.role}
              </Typography>
            </Box>
          )}
        </Stack>
      )}
    </Box>
  );

  if (mobile) {
    return (
      <Drawer
        variant="temporary"
        open={open}
        onClose={onToggle}
        ModalProps={{ keepMounted: true }}
        sx={{ "& .MuiDrawer-paper": { width: SIDEBAR_WIDTH, borderRight: "1px solid", borderColor: "divider" } }}
      >
        {drawerContent}
      </Drawer>
    );
  }

  return (
    <Drawer
      variant="permanent"
      sx={{
        width,
        flexShrink: 0,
        transition: theme.transitions.create("width"),
        "& .MuiDrawer-paper": {
          width,
          transition: theme.transitions.create("width"),
          overflowX: "hidden",
          borderRight: "1px solid",
          borderColor: "divider",
        },
      }}
    >
      {drawerContent}
    </Drawer>
  );
}

export { SIDEBAR_WIDTH, SIDEBAR_WIDTH_COLLAPSED };
